import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { throwHatTool } from '../hats/ThrowHatTool';
import { annotateTool } from './AnnotateTool';
import { confettiTool } from './ConfettiTool';
import { GesturesWidget } from './GesturesWidget';
import { pingTool } from './PingTool';

export const gesturesToolboxItem = ToolboxItem({
    id: 'gestures',
    label: 'Gestures',
    icon: 'deqo://icons/i8/lightning-bolt',
    ui: GesturesWidget,
    skipEquip: true,
    weight: 4000,
    shortcut: 'W',
    tools: [
        pingTool,
        annotateTool,
        confettiTool,
        throwHatTool,
    ]
});
